import React from 'react';
import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const PopupSectionInfo = ({ children }) => (
  <div className={cx('container')}>
    <div className={cx('component')}>{children}</div>
  </div>
);
